import { render, staticRenderFns } from "./NotebookSidebar.vue?vue&type=template&id=fe27646a&scoped=true"
import script from "./NotebookSidebar.vue?vue&type=script&lang=ts"
export * from "./NotebookSidebar.vue?vue&type=script&lang=ts"
import style0 from "./NotebookSidebar.vue?vue&type=style&index=0&id=fe27646a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe27646a",
  null
  
)

export default component.exports